import { render, staticRenderFns } from "./officeautopage.vue?vue&type=template&id=46b84c7e"
import script from "./officeautopage.vue?vue&type=script&lang=js"
export * from "./officeautopage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports